<!-- Banner principal — look glassmorphism con blobs decorativos -->
<div
  class="isolate flex items-center justify-center h-[50px] overflow-hidden fixed top-0 left-0 right-0 z-40 bg-gray-900 dark:bg-gray-800 after:pointer-events-none after:absolute after:inset-x-0 after:bottom-0 after:h-px after:bg-white/10"
>
  <!-- Blob decorativo izquierdo -->
  <div
    aria-hidden="true"
    class="absolute top-1/2 left-[max(-7rem,calc(50%-52rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl pointer-events-none"
  >
    <div
      style="
        clip-path: polygon(
          74.8% 41.9%,
          97.2% 73.2%,
          100% 34.9%,
          92.5% 0.4%,
          87.5% 0%,
          75% 28.6%,
          58.5% 54.6%,
          50.1% 56.8%,
          46.9% 44%,
          48.3% 17.4%,
          24.7% 53.9%,
          0% 27.9%,
          11.9% 74.2%,
          24.9% 54.1%,
          68.6% 100%,
          74.8% 41.9%
        );
      "
      class="aspect-[577/310] w-[36rem] bg-gradient-to-r from-primary to-primary-muted opacity-40"
    ></div>
  </div>

  <!-- Blob decorativo derecho -->
  <div
    aria-hidden="true"
    class="absolute top-1/2 left-[max(45rem,calc(50%+8rem))] -z-10 -translate-y-1/2 transform-gpu blur-2xl pointer-events-none"
  >
    <div
      style="
        clip-path: polygon(
          74.8% 41.9%,
          97.2% 73.2%,
          100% 34.9%,
          92.5% 0.4%,
          87.5% 0%,
          75% 28.6%,
          58.5% 54.6%,
          50.1% 56.8%,
          46.9% 44%,
          48.3% 17.4%,
          24.7% 53.9%,
          0% 27.9%,
          11.9% 74.2%,
          24.9% 54.1%,
          68.6% 100%,
          74.8% 41.9%
        );
      "
      class="aspect-[577/310] w-[36rem] bg-gradient-to-r from-primary-muted to-primary-dark opacity-40"
    ></div>
  </div>

  <!-- Contenido -->
  <div class="w-full max-w-7xl px-2 sm:px-6">
    @if (isVisible) {
      <!-- Desktop: centrado normal -->
      <div class="hidden md:flex items-center justify-center">
        <div class="flex items-center gap-4 sm:gap-6 whitespace-nowrap">
          <p class="text-sm leading-6 text-gray-100">
            @if (isLastChance) {
              <strong class="font-semibold text-white"
                >Ultima oportunidad</strong
              >
              <svg
                viewBox="0 0 2 2"
                aria-hidden="true"
                class="mx-2 inline h-0.5 w-0.5 fill-current text-white/40"
              >
                <circle r="1" cx="1" cy="1" />
              </svg>
              {{ getOfferText() }}
            } @else {
              <strong class="font-semibold text-white"
                >Oferta por tiempo limitado</strong
              >
              <svg
                viewBox="0 0 2 2"
                aria-hidden="true"
                class="mx-2 inline h-0.5 w-0.5 fill-current text-white/40"
              >
                <circle r="1" cx="1" cy="1" />
              </svg>
              {{ getOfferText() }}
            }
          </p>

          <div class="w-px h-4 bg-white/20"></div>

          <div class="flex items-center gap-2">
            <span class="text-xs text-white/60 uppercase tracking-wide"
              >Termina en</span
            >
            <div
              class="flex items-center gap-1 font-mono text-sm font-semibold text-white"
            >
              <span>{{ timeLeft.hours.toString().padStart(2, "0") }}h</span>
              <span class="text-white/40">:</span>
              <span>{{ timeLeft.minutes.toString().padStart(2, "0") }}m</span>
              <span class="text-white/40">:</span>
              <span>{{ timeLeft.seconds.toString().padStart(2, "0") }}s</span>
            </div>
          </div>
        </div>
      </div>

      <!-- Móvil: marquee infinito -->
      <div class="md:hidden urgency-wrapper">
        <div class="urgency-content">
          <!-- Contenido original -->
          <div class="flex items-center gap-4 whitespace-nowrap px-8">
            <p class="text-sm text-gray-100">
              @if (isLastChance) {
                <strong class="font-semibold text-white"
                  >Ultima oportunidad</strong
                >
                <svg
                  viewBox="0 0 2 2"
                  aria-hidden="true"
                  class="mx-2 inline h-0.5 w-0.5 fill-current text-white/40"
                >
                  <circle r="1" cx="1" cy="1" />
                </svg>
                {{ getOfferText() }}
              } @else {
                <strong class="font-semibold text-white"
                  >Oferta por tiempo limitado</strong
                >
                <svg
                  viewBox="0 0 2 2"
                  aria-hidden="true"
                  class="mx-2 inline h-0.5 w-0.5 fill-current text-white/40"
                >
                  <circle r="1" cx="1" cy="1" />
                </svg>
                {{ getOfferText() }}
              }
            </p>
            <div class="w-px h-4 bg-white/20"></div>
            <div class="flex items-center gap-2">
              <span class="text-xs text-white/60 uppercase tracking-wide"
                >Termina en</span
              >
              <div
                class="flex items-center gap-1 font-mono text-sm font-semibold text-white"
              >
                <span>{{ timeLeft.hours.toString().padStart(2, "0") }}h</span>
                <span class="text-white/40">:</span>
                <span>{{ timeLeft.minutes.toString().padStart(2, "0") }}m</span>
                <span class="text-white/40">:</span>
                <span>{{ timeLeft.seconds.toString().padStart(2, "0") }}s</span>
              </div>
            </div>
          </div>
          <!-- Contenido duplicado para scroll infinito -->
          <div class="flex items-center gap-4 whitespace-nowrap px-8">
            <p class="text-sm text-gray-100">
              @if (isLastChance) {
                <strong class="font-semibold text-white"
                  >Ultima oportunidad</strong
                >
                <svg
                  viewBox="0 0 2 2"
                  aria-hidden="true"
                  class="mx-2 inline h-0.5 w-0.5 fill-current text-white/40"
                >
                  <circle r="1" cx="1" cy="1" />
                </svg>
                {{ getOfferText() }}
              } @else {
                <strong class="font-semibold text-white"
                  >Oferta por tiempo limitado</strong
                >
                <svg
                  viewBox="0 0 2 2"
                  aria-hidden="true"
                  class="mx-2 inline h-0.5 w-0.5 fill-current text-white/40"
                >
                  <circle r="1" cx="1" cy="1" />
                </svg>
                {{ getOfferText() }}
              }
            </p>
            <div class="w-px h-4 bg-white/20"></div>
            <div class="flex items-center gap-2">
              <span class="text-xs text-white/60 uppercase tracking-wide"
                >Termina en</span
              >
              <div
                class="flex items-center gap-1 font-mono text-sm font-semibold text-white"
              >
                <span>{{ timeLeft.hours.toString().padStart(2, "0") }}h</span>
                <span class="text-white/40">:</span>
                <span>{{ timeLeft.minutes.toString().padStart(2, "0") }}m</span>
                <span class="text-white/40">:</span>
                <span>{{ timeLeft.seconds.toString().padStart(2, "0") }}s</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    } @else {
      <!-- Barra de envío -->
      <div class="flex items-center justify-center">
        <p class="text-sm leading-6 text-gray-100">
          <strong class="font-semibold text-white">Envío Express 24h</strong>
          <svg
            viewBox="0 0 2 2"
            aria-hidden="true"
            class="mx-2 inline h-0.5 w-0.5 fill-current text-white/40"
          >
            <circle r="1" cx="1" cy="1" />
          </svg>
          <strong class="font-semibold text-white">Envío gratis</strong> a Lima
          Metropolitana
        </p>
      </div>
    }
  </div>
</div>
